import React, {FC} from "react";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {HasFormIdModel, ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportFollowItemBalance} from "../../../serviceBroker/itemsReportApiServiceBroker";

interface ReportFollowItemBalancePage extends HasFormIdModel {
}

export const ReportFollowItemBalancePage: FC<ReportFollowItemBalancePage> = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportFollowItemBalance}
            searchHeader={getPageNameByPageId(PageEnum.ReportFollowItemsBalance)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportFollowItemsBalance}
        />
    );
};
